module.exports = __webpack_public_path__ + "img/workflow.d17542f2.png";